import React from 'react';
import { Link } from 'react-router-dom';
import SectionContainer from '../../common/SectionContainer';
import FieldRow from '../../common/FieldRow';
import { antecedentes as antFn, r23 as r23Fn, liquidacion as liqFn, validar } from '../formulas';

// TAXI parte en el AT 2025: el F22 del año anterior a ese nunca está en el sistema
const PRIMER_ANIO_TRIBUTARIO = 2025;

/**
 * Antecedentes de la renta 14 D N°8: resumen de la DJ 1947 que se usa y los datos del
 * recuadro 23 que no vienen de ella. Es la única sección que se edita: la base
 * imponible se corrige en la DJ 1947.
 */
const AntecedentesSection = ({ data, updateField }) => {
  const ant = data.antecedentes;
  const dj = data.dj1947;
  const problema = validar(data);
  const updateAnt = (field, value) => updateField('antecedentes', field, value);

  return (
    <SectionContainer title="Antecedentes" subtitle="DJ 1947 del año y datos del CPTS (recuadro 23)">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">I. DJ 1947 del AT {data.anioTributario}</h4>
        {problema ? (
          <div className="f22-aviso">
            {problema} <Link to={`/declaraciones-juradas?anio=${data.anioTributario}`}>Ir a Declaraciones juradas</Link>
          </div>
        ) : (
          <>
            <p className="f22-hint">
              La base imponible, los PPM y el reparto a los propietarios salen de la DJ 1947 guardada. Si la cambias,
              vuelve a calcular la renta. <Link to={`/declaraciones-juradas?anio=${data.anioTributario}`}>Ir a Declaraciones juradas</Link>
            </p>
            <FieldRow label="Base imponible asignable a los propietarios" code="1712" value={r23Fn.baseImponible(data)} computed />
            <FieldRow label="PPM puestos a disposición de los propietarios" value={liqFn.ppmPuestosADisposicion(data)} computed />
            <FieldRow label="Propietarios informados" value={(dj.reparto || []).length} type="number" computed />
          </>
        )}
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">II. Capital propio tributario inicial</h4>
        <p className="f22-hint">
          {data.anioTributario <= PRIMER_ANIO_TRIBUTARIO
            ? `CPT o CPTS final del F22 del AT ${data.anioTributario - 1} (códigos 1581 o 1583). Ese año no está en TAXI: ingrésalo a mano.`
            : `CPT o CPTS final del F22 del año anterior. TAXI lo propone desde la renta pagada cargada del AT ${data.anioTributario - 1}; si no está cargada, ingrésalo a mano.`}
        </p>
        <FieldRow label="CPT o CPTS positivo inicial" code="1580" sign="(+)" value={ant.cptInicialPositivo} onChange={(v) => updateAnt('cptInicialPositivo', v)} />
        <FieldRow label="CPT o CPTS negativo inicial" code="1582" sign="(-)" value={ant.cptInicialNegativo} onChange={(v) => updateAnt('cptInicialNegativo', v)} />
        <FieldRow label="Capital aportado empresas que inician actividades (sin CPT inicial, desde Socios)" code="1573" sign="(+)" value={antFn.capitalAportado1573(data)} computed />
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">III. Movimientos de capital y otras partidas</h4>
        <FieldRow label="Aumentos (efectivos) de capital del ejercicio" code="1574" sign="(+)" value={ant.aumentosCapital} onChange={(v) => updateAnt('aumentosCapital', v)} />
        <FieldRow label="Disminuciones (efectivas) de capital del ejercicio" code="1575" sign="(-)" value={ant.disminucionesCapital} onChange={(v) => updateAnt('disminucionesCapital', v)} />
        <FieldRow label="Intereses y multas fiscales pagados" code="1577" sign="(-)" value={ant.pagoInteresesMultas} onChange={(v) => updateAnt('pagoInteresesMultas', v)} />
        <FieldRow label="IDPC pagado en el año (renta del año anterior)" code="1577" sign="(-)" value={ant.pagoIDPCAnterior} onChange={(v) => updateAnt('pagoIDPCAnterior', v)} />
        <FieldRow label="Otras partidas a agregar" code="1584" sign="(+)" value={ant.otrasPartidasAgregar} onChange={(v) => updateAnt('otrasPartidasAgregar', v)} />
        <FieldRow label="Otras partidas a deducir" code="1585" sign="(-)" value={ant.otrasPartidasDeducir} onChange={(v) => updateAnt('otrasPartidasDeducir', v)} />
      </div>
    </SectionContainer>
  );
};

export default AntecedentesSection;
